import React, { useCallback, useEffect, useState } from 'react';
import { AppRemixIcon } from '@/layout/AppComponents';
import { useParams, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import axios from 'axios';
import { Accordion } from 'react-bootstrap';
import Translator from '../../../components/helpers/Translator';
import Sidebar from '../../../Sidebar/Sidebar';
import * as currentPageAction from '../../../../store/actions/currentPageAction';
import { axiosPath, path } from '../../../../routing/helpers/router';
import ErrorHandler from '../../../components/error/ErrorHandler';
import colors from '../../../../constants/colors';

export default function CommunicationPipelineModuleSidebar() {
  const { moduleBridgeHex } = useParams();
  const auth = useSelector((state) => state.auth);
  const unseenCountInquiryCommunications = useSelector(
    (state) => state.currentPage?.unseenCountInquiryCommunications,
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [userType] = useState('admin');

  useEffect(() => {
    return () => {
      dispatch(currentPageAction.empty());
    };
  }, []);

  const loadCommunicationAlerts = useCallback(async () => {
    axios
      .post(
        axiosPath(
          'api_r_user_module_communicationPipeline_admin_communication_alerts',
        ),
        {
          moduleBridgeHex,
          type: userType,
        },
      )
      .then((r) => {
        dispatch(
          currentPageAction.change(
            'unseenCountInquiryCommunications',
            r?.data?.unseenCountInquiryCommunications,
            true,
          ),
        );
      })
      .catch((e) => dispatch(ErrorHandler(e)));
  }, [moduleBridgeHex, userType]);

  useEffect(() => {
    loadCommunicationAlerts();
  }, []);

  return (
    <>
      <Sidebar>
        <img
          src={auth.user?.client?.logoUrl}
          className="img-fluid"
          alt={auth.user?.client?.name}
          title={auth.user?.client?.name}
        />
        <Accordion>
          <ul>
            <li>
              <div
                className="sidebar-element"
                onClick={() =>
                  navigate(
                    path({
                      name: 'user_module_communicationPipeline_home',
                      params: {
                        moduleBridgeHex,
                      },
                    }),
                  )
                }
              >
                <AppRemixIcon icon="file-copy-2" className="sidebar-icon" />{' '}
                <span className="sb-title">
                  <Translator
                    file="module-communicationPipeline"
                    name="complaints"
                  />
                </span>
              </div>
            </li>
            <li>
              <div
                className="sidebar-element"
                onClick={() =>
                  navigate(
                    path({
                      name: 'user_module_communicationPipeline_admin_inquiry_list',
                      params: {
                        moduleBridgeHex,
                      },
                    }),
                  )
                }
              >
                <AppRemixIcon icon="message-2" className="sidebar-icon" />{' '}
                <span className="sb-title">
                  <Translator
                    file="module-communicationPipeline"
                    name="consult"
                  />{' '}
                  {unseenCountInquiryCommunications > 0 && (
                    <span className="ml-1">
                      <AppRemixIcon
                        icon="notification"
                        color={colors.bootstrapWarning}
                        filled
                      />
                    </span>
                  )}
                </span>
              </div>
            </li>
          </ul>
        </Accordion>
      </Sidebar>
    </>
  );
}
